module.exports = __webpack_public_path__ + "img/smiley_2.5e71e451.png";